import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPatient } from "../store/slices/assessment";

function useAuditLogin(hasRegisteredLogin, setHasRegisteredLogin) {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (hasRegisteredLogin || !isAuthenticated) {
      return;
    }

    const registerLogin = async () => {
      setHasRegisteredLogin(true);
      let { data } = await axios.post("/RetailAssessmentUser-dev", user);
      data = JSON.parse(data?.body);
      if (data?.firstName) {
        dispatch(
          setPatient({
            firstName: data.firstName,
            lastName: data.lastName,
            dob: data.dob,
          })
        );
      } else {
        let p = JSON.parse(sessionStorage.getItem("anonymous_user_details"));
        if (p && p?.firstName) {
          dispatch(setPatient(p));
          await axios.put("RetailAssessmentUserUpdate", {
            ...p,
            sub: user.sub,
          });
        }
      }
      sessionStorage.removeItem("anonymous_user_details");
    };
    registerLogin();
  }, [isAuthenticated]);
  return null;
}

export default useAuditLogin;
